import { z } from "zod";
/** Contractual economic classification. Cashflow netting, PAIR labels and venue
 * names are not evidence that a bilateral is physical or financial. */
export const BilateralSettlementNatureSchema = z.enum(["physical", "financial"]);
export function classifySettlementKind(input) {
    if (input.origin === "cleared")
        return "cleared";
    if (input.origin !== "bilateral")
        return "unclassified";
    if (input.bilateralSettlementNature === "physical")
        return "physical";
    if (input.bilateralSettlementNature === "financial")
        return "otc_financial";
    return "unclassified";
}
export function bilateralSettlementNatureLabel(nature) {
    return nature === "physical" ? "Physical delivery" : nature === "financial" ? "Financial OTC" : "Unclassified bilateral";
}
//# sourceMappingURL=eex-settlement-nature.js.map